import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { IN_ROOM_DINING_ADDONS_EDIT } from '../../../../../constants/InRoomDiningConst';
import {
  RBAC_PERMISSION_LEVEL_FULL_ACCESS,
  RBAC_TYPE_SERVICES_IN_ROOM_DINING,
} from '../../../../../constants/RoleConsts';
import DetailViewLayout from '../../../../../shared/detail-view-layout/Detail-View-Layout';
import { inRoomDiningAddOnSelector } from '../../../servicesSlice';
import InRoomDiningAddonViewDetail from './Addon-View-Details';

const InRoomDiningAddonView = (props) => {
  const { addon, toggleDrawer, onViewToggle, permissions } = props;
  const inRoomDiningAddon = useSelector(inRoomDiningAddOnSelector);
  const [tabValue, setTabValue] = useState(0);
  const [currAddon, setCurrAddon] = useState(null);

  useEffect(() => {
    if (inRoomDiningAddon.length) {
      let addonObj = { ...inRoomDiningAddon.find((temp) => temp.id === addon.id) };
      setCurrAddon(addonObj);
    }
  }, [inRoomDiningAddon]);

  const onOpenDrawer = (type) => {
    toggleDrawer(type, true, currAddon);
  };

  const onClickEdit = (event) => {
    onOpenDrawer(IN_ROOM_DINING_ADDONS_EDIT);
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const renderScreen = () => {
    return <InRoomDiningAddonViewDetail tabValue={tabValue} addon={currAddon} />;
  };

  return (
    <>
      {currAddon && (
        <DetailViewLayout
          onClickEdit={onClickEdit}
          renderScreen={renderScreen}
          handleTabChange={handleTabChange}
          tabValue={tabValue}
          onViewToggle={onViewToggle}
          title={currAddon.name}
          createdUserId={currAddon.createdBy}
          isEditable={
            permissions[RBAC_TYPE_SERVICES_IN_ROOM_DINING] === RBAC_PERMISSION_LEVEL_FULL_ACCESS
          }
          tabClass='col-md-6'
        />
      )}
    </>
  );
};

export default InRoomDiningAddonView;
